{
  "de": {
    "gallery": {
      "headers": {
        "title": "Finde fertiges Unterrichtsmaterial als OER"
      }
    }
  }
}
